module.exports = __webpack_public_path__ + "static/media/RoadmapediaLogo.7f8a104a.png";